(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["melokea-market-selector"] && !Shopify.designMode) return;
  try {
    (() => {
  const mountCurrency = () => {
    const slot = document.getElementById('MelokeaCurrencySlot');
    const widget = document.querySelector('.doubly-float');
    if (!slot || !widget) return false;
    if (!slot.contains(widget)) slot.appendChild(widget);
    slot.classList.add('has-currency');
    const control = widget.querySelector('[role="combobox"]');
    if (control) control.setAttribute('aria-label', slot.getAttribute('aria-label'));
    return true;
  };
  const marketRow = document.querySelector('.melokea-market-row');
  if (marketRow && 'IntersectionObserver' in window) {
    const visibility = new IntersectionObserver(entries => {
      document.body.classList.toggle('melokea-market-in-view', entries[0].isIntersecting);
    });
    visibility.observe(marketRow);
  }
  if (!mountCurrency()) {
    const observer = new MutationObserver(() => {
      if (mountCurrency()) observer.disconnect();
    });
    observer.observe(document.body, {childList:true, subtree:true});
    setTimeout(() => observer.disconnect(), 30000);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
